import styled from "styled-components";

export const StyledEventSummaryList = styled.ul`
  list-style: none;
`;

export const StyledEventSummaryListItem = styled.li``;
